$(document).ready(function () {
  const MAX_VISIBLE_DOTS = 5;

  function updatePagingInfo(slick, currentSlide) {
    const $dots = slick.$slider.find(".slick-dots li");
    const activeIndex = $dots.filter(".slick-active").index();
    const total = $dots.length;
    slick.$slider.closest(".tab-content").find(".pagingInfo").text(`${activeIndex + 1}/${total}`);
    slick.$slider.closest(".tab-contents").find(".pagingInfo").text(`${activeIndex + 1}/${total}`);
  }

  function limitVisibleDots(slick) {
    if (!slick.$dots) return;

    const $dots = slick.$dots.find("li");
    const totalDots = $dots.length;
    const activeIndex = $dots.filter(".slick-active").index();

    let start = Math.max(0, activeIndex - Math.floor(MAX_VISIBLE_DOTS / 2));
    let end = Math.min(totalDots, start + MAX_VISIBLE_DOTS);

    if (end - start < MAX_VISIBLE_DOTS) {
      start = Math.max(0, end - MAX_VISIBLE_DOTS);
    }

    $dots.hide().slice(start, end).show();
  }

  // ✅ Bind events BEFORE slick init
  $('.new-arrival-sec-pro-slider-2').on('init reInit', function (event, slick) {
    updatePagingInfo(slick, slick.currentSlide);
    limitVisibleDots(slick);
  });

  $('.new-arrival-sec-pro-slider-2').on('afterChange', function (event, slick, currentSlide) {
    updatePagingInfo(slick, currentSlide);
    limitVisibleDots(slick);
  });

  // ✅ Initialize slick
  $('.new-arrival-sec-pro-slider-2').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1
        }
      }
    ]
  });

  // ✅ Tab switching
  $('.new-arrival-sec').each(function () {
    const $section = $(this);

    $section.find('.tab').on('click', function (evt) {
      evt.preventDefault();

      // Update tab UI
      $section.find('.tab').removeClass('active');
      $(this).addClass('active');

      $section.find('.tab-content').removeClass('active');
      const targetSelector = $(this).data('toggles-target');
      const $targetContent = $section.find(targetSelector);
      $targetContent.addClass('active');
      $targetContent.find('.new-arrival-sec-pro-item').css('opacity',0)
      const $slider = $('.new-arrival-sec-pro-slider-2');

      setTimeout(function(){
        $(".new-arrival-sec-pro-slider-2").slick("slickGoTo",0);
      },1)

      if ($slider.length && $slider.hasClass('slick-initialized')) {
        // ✅ JUST refresh and go to first
        //$slider.slick('refresh');
        $slider.slick('slickGoTo', 0);
        setTimeout(function(){ 
          $targetContent.find('.new-arrival-sec-pro-item').css('opacity',1)
        },500)
        

        // ✅ Update pagination manually
        const slickInstance = $slider.slick('getSlick');
        updatePagingInfo(slickInstance, 0);
        limitVisibleDots(slickInstance);
        //$('.new-arrival-sec-pro-slider-2').slick('slickGoTo',0)
      }
    });
  });

  // ✅ Show first tab on page load
  $('.new-arrival-sec').each(function () {
    $(this).find('.tab').first().trigger('click');
  });
  $('body').on('click', '.slick-arrow.slick-disabled', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
  })
});
